module.exports = __webpack_public_path__ + "img/ic_services_heating.3e095522.svg";